import React from 'react'
import Chart from 'react-apexcharts'

const BarChart = ({ data, horizontal = false, max = 100, seriesName = 'Jobs' }) => {
  const series = [
    {
      name: seriesName,
      data: data?.jobs // Data for the bar heights
    }
  ]

  const options = {
    chart: {
      type: 'bar',
      toolbar: {
        show: false // Hide the toolbar
      }
    },
    plotOptions: {
      bar: {
        horizontal: horizontal, // Make bars vertical
        columnWidth: '45%', // Adjust the column width
        endingShape: 'rounded' // Rounded bars like in the UI example
      }
    },
    dataLabels: {
      enabled: false // Disable the data labels
    },
    xaxis: {
      categories: data?.name, // Categories on the X-axis
      labels: {
        style: {
          fontSize: '12px'
        },
        formatter: function (value) {
          return value.length > 20 ? value.substring(0, 20) + '...' : value
        }
      }
    },
    yaxis: {
      labels: {
        // formatter: (val) => `${Math.round(val)}` // Ensure integer labels
        formatter: (val) => (horizontal ? `${val}` : `${Math.round(val)}`)
      },
      max: max, // Max value for the Y-axis
      min: 0,
      // tickAmount: max, // Adjust tick amount based on max value
      forceNiceScale: true // Ensure nice scale distribution
    },
    fill: {
      opacity: 1,
      colors: ['#77C9D4'] // Set bar color
    },
    tooltip: {
      shared: false,
      intersect: true,
      y: {
        formatter: (val) => `${val}` // Tooltip shows percentage values
      }
    },
    grid: {
      borderColor: '#e7e7e7' // Grid line color
    },
    legend: {
      show: false // Hide the legend
    }
  }

  return <Chart options={options} series={series} type="bar" height="300" />
}

export default BarChart
